import React, {useEffect} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

const AdminMainlayout = (props) => {

    let navigate = useNavigate();
    const userdata = useSelector((store) => store.userReducer.userdata);

    useEffect(() => {
                if (userdata && Object.keys(userdata).length > 0) {
                  //   fetchdata();
                  
                } else {
                  navigate("/login");
                }
              }, []);
    return (
       <div className="adminmainlayout-maindiv">
            <div className="adminmainlayout-leftdiv">
                <Sidebar />
            </div>
            <div className="adminmainlayout-rightdiv">
                <div className="adminmainlayout-navbar">
                    <Navbar title={props?.title} />
                </div>
                <div className="adminmainpage">
                    {props.children}
                </div>
            </div>
       </div>
    )
}

export default AdminMainlayout